/** 
 * @desc 首页曝光埋点 
 */
export default {
  // 首页基本展示
  sailing_c_x_homepage_common_sw: 'address_id',
  // 首页店铺
  sailing_c_x_homepage_realexposure_sw: 'shop_id',
  // topic二级页面
  sailing_c_x_homepage_topic_sw: 'rec_id',
  sailing_c_x_homepage_topic_shop_sw: 'shop_id',
  // banner
  sailing_c_x_homepage_banner_sw: 'banner_id',
  // banner触发的活动落地页
  sailing_c_x_homepage_activity_landing_sw: 'activity_id',
  sailing_c_x_homepage_activity_landing_shop_sw: 'shop_id',
  sailing_c_x_homepage_activity_landing_item_sw: 'item_id',
  // 品类导航
  sailing_c_x_homepage_category_sw: 'category_id',
  // 筛选器
  sailing_c_x_homepage_filter_sw: '',
  sailing_c_x_homepage_filter_none_sw: '',
  // 搜索
  sailing_c_x_search_panel_sw: 'poplular_recid',
  // 通知组件	
  sailing_c_x_homepage_notice_sw: '',
  // 搜索结果页店铺实曝光
  sailing_c_x_searchresult_realexposure_sw:'shop_id',
  // EFO 菜品
  sailing_c_x_top_item_realexposure_sw: 'item_id',
}
